/**
 * PageStub — переиспользуемый каркас экрана-заглушки.
 *
 * Для экранов, где backend-данных ещё нет: показывает заголовок, описание
 * секций по дизайну v4 и явную пометку «каркас» (TODO). Помогает не плодить
 * почти одинаковые файлы и держать FRONTEND_CODING_STANDARDS (≤200 LOC).
 */
export interface PageStubProps {
  title: string;
  /** Краткое описание назначения экрана. */
  description: string;
  /** Перечень секций/блоков экрана по дизайну v4. */
  sections: ReadonlyArray<string>;
  /** Источник данных: реальный endpoint или «замокано / TODO». */
  dataSource?: string;
  testId?: string;
}

export function PageStub({
  title,
  description,
  sections,
  dataSource,
  testId,
}: PageStubProps): JSX.Element {
  return (
    <section className="hsc-page" data-testid={testId ?? 'page-stub'}>
      <h1 className="hsc-page__title">{title}</h1>
      <p className="admin-stub__desc">{description}</p>
      <ul className="admin-stub__sections">
        {sections.map((s) => (
          <li key={s}>{s}</li>
        ))}
      </ul>
      {dataSource && (
        <p className="admin-stub__source">
          <strong>Данные:</strong> {dataSource}
        </p>
      )}
      <p className="admin-stub__badge">Каркас · содержимое в разработке</p>
    </section>
  );
}
